<template>
<Box @close="close({})" v-if="ready">
    <template #top>Orden de {{ orden_compra.ord_tipo_orden_descripcion }}: {{ orden_compra.ord_code }}</template>
    <template #center>
        <b-tabs v-model="active_tab" :animated="false" @input="changeTab($event)" type="is-boxed" size="is-small" position="is-left">
            <!-- ---------------------------------------- Información ---------------------------------------- -->
            <b-tab-item label="Información">
                <div style="text-align: right">
                    <b-tag :class="orden_compra.ore_styles">{{ orden_compra.ore_descripcion }}</b-tag>
                </div>
                <br>
                <div class="nj-grid">
                    <Info label="Codigo">{{ orden_compra.ord_code }}</Info>
                    <Info label="Tipo">{{ orden_compra.ord_tipo_orden_descripcion }}</Info>
                    <Info label="Condición Comercial">{{ orden_compra.coc_descripcion }}</Info>
                </div>
                <div class="nj-grid">
                    <Info label="Moneda">{{ orden_compra.mon_descripcion }}</Info>
                    <Info label="Metodo pago">{{ orden_compra.mep_descripcion }}</Info>
                    <Info label="Fecha orden">{{ orden_compra.ord_fecha_orden }}</Info>
                </div>
                <div>
                    <Info label="Referencia">{{ orden_compra.ord_referencia }}</Info>
                    <Info label="Observacion">{{ orden_compra.ord_observacion ? orden_compra.ord_observacion : '-' }}</Info>
                </div>
                <br>
                <b-table :data="orden_compra.orden_detalle_list">
                    <template slot-scope="props">
                        <b-table-column label="Item" header-class="is-info">{{ props.row.oci_descripcion }}</b-table-column>
                        <b-table-column label="Cantidad" header-class="is-info">{{ props.row.oci_cantidad }}</b-table-column>
                        <b-table-column label="Precio U." header-class="is-info">{{ setTagMoney({ amount: props.row.oci_precio_unitario, currency: props.row.mon_descripcion }) }}</b-table-column>
                        <b-table-column label="Importe" header-class="is-info">{{ setTagMoney({ amount: props.row.oci_precio_unitario * props.row.oci_cantidad, currency: props.row.mon_descripcion })
                            }}</b-table-column>
                    </template>
                </b-table>
                <br>
                <div class="nj-flex justify-end g12">
                    <Info direction="right" label="Subtotal">{{ orden_compra.ord_monto_sigv }}</Info>
                    <Info direction="right" :label="labelImpuesto(item)" v-for="item in orden_compra.orden_impuesto_list" :key="item.ori_id">{{ labelImpuestoValor(item) }}</Info>
                    <Info direction="right" label="Total">{{ orden_compra.ord_monto_cigv }}</Info>
                </div>
            </b-tab-item>
            <!-- ---------------------------------------- Pagos ---------------------------------------- -->
            <b-tab-item label="Pagos" v-if="activarPagos">
                <b-table :data="ordenes_pago">
                    <template slot-scope="props">
                        <b-table-column label="N°" header-class="is-info">{{ props.row.opg_numero }}</b-table-column>
                        <b-table-column label="Descripción" header-class="is-info">{{ props.row.opg_descripcion }}</b-table-column>
                        <b-table-column label="Total" header-class="is-info">{{ props.row.opg_total }}</b-table-column>
                        <b-table-column label="Detracción" header-class="is-info">{{ props.row.opg_detraccion }}</b-table-column>
                        <b-table-column label="Pago" header-class="is-info">{{ props.row.opg_pago }}</b-table-column>
                        <b-table-column label="Fecha aprobación" header-class="is-info">{{ props.row.opg_fecha_aprobacion }}</b-table-column>
                        <b-table-column label="Estado" header-class="is-info">
                            <b-tag :class="props.row.opg_estado_styles">{{ props.row.opg_estado_nombre }}</b-tag>
                        </b-table-column>
                    </template>
                </b-table>
            </b-tab-item>
        </b-tabs>
    </template>
    <template #bottom>

    </template>
</Box>
</template>
<script>
import { OrdenCompraService, OrdenPagoService, ResponseStatus } from "../../services"
import { Tags, Toast, Tools, Validator } from "../../util"
import { Box, Info } from "../components"
import Button from "../components/Button.vue"

export default {
    name: "ProveedorVerOrdenCompra",
    props: {
        ord_id: {
            type: Number,
            required: true
        }
    },
    components: {
        Box,
        Info,
        Button,
    },
    data() {
        return {
            ready: false,
            active_tab: 0,
            activarPagos: false,
            orden_compra: null,
            ordenes_pago: [],
        }
    },
    methods: {
        obtener() {
            OrdenCompraService
                .obtener({
                    orden_compra: {
                        ord_id: this.ord_id
                    }
                })
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.orden_compra = response.data
                        this.ready = Validator.isNotNull(this.orden_compra)
                        this.activarPagos = this.orden_compra.opg_numero_ordenes_pago != 0
                    }
                    else {
                        Toast.error(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                })
        },
        changeTab(tab) {
            if (tab == 1) {
                // * tab: ordenes de pago
                if (this.ordenes_pago.length == 0) {
                    OrdenPagoService
                        .buscarxProveedorOrdenCompra({
                            orden_pago: {
                                ord_id: this.orden_compra.ord_id
                            }
                        })
                        .then(response => {
                            if (ResponseStatus.isSuccess(response)) {
                                this.ordenes_pago = response.data
                            }
                            else {
                                Toast.error(response.message)
                            }
                        })
                        .catch(error => {
                            Toast.error(error)
                        })
                }
            }
        },
        close({
            view = null,
        }) {
            this.$emit("close", {
                view
            })
        },
        setTagMoney({
            sign = "",
            amount,
            currency
        }) {
            return Tags.money({
                sign,
                amount,
                currency
            })
        },
        labelImporte(item) {
            return `${item.mon_simbolo} ${item.oci_precio_unitario * item.oci_cantidad}`
        },
        labelImpuesto(item) {
            return `${item.ori_descripcion} (${item.ori_valor * 100}%)`
        },
        labelImpuestoValor(item) {
            let sign = item.ori_tipo == 3 && item.ori_valor_aplicado != 0
                ? "-"
                : ""
            return `${sign}${item.ori_valor_aplicado}`
        },
    },
    mounted() {
        this.obtener()
    }
}
</script>

<style scoped></style>